import { isPlatformServer } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { REQUEST_SOURCE_HEADER_NAME } from '../constants';

export const requestSourceInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const source = isPlatformServer(platformId) ? 'ssr' : 'browser';

  return next(req.clone({
    headers: req.headers.set(REQUEST_SOURCE_HEADER_NAME, source),
  }));
};
